import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { Init2FADocument } from 'graphql/generated/graphql';

const useInit2FA = (): [string | null, boolean] => {
  const { data, loading } = useQuery(Init2FADocument, { fetchPolicy: 'no-cache' });

  const qrCode = get(data, 'init2FA', null);

  return [qrCode, loading];
};

export default useInit2FA;
